export default [{
  path: '/event',
  name: 'event',
  component: resolve => require(['@/views/event/event.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, {
  path: '/eventDetail/:id',
  name: 'eventDetail',
  component: resolve => require(['@/views/event/eventDetail.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, {
  path: '/myEvent',
  name: 'myEvent',
  component: resolve => require(['@/views/event/myEvent.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/event/event.js